import { Component } from '@angular/core';
import { AdminActionsDirective } from '@app/main/admin/directives/admin-actions.directive';
import { AdminService } from '../../../admin.service';
import { SnackService } from '@shared/services/snack.service';
import { GlossaryService } from '@shared/services/glossary.service';
import { IGlossary } from '@shared/interfaces';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-toolbar-glossary',
    templateUrl: './admin-toolbar-glossary.component.html',
    styleUrls: ['./admin-toolbar-glossary.component.scss'],
    standalone: false
})
export class AdminToolbarGlossaryComponent extends AdminActionsDirective {
    searchValue: string;

    constructor(
        private glossaryService: GlossaryService,
        private snack: SnackService,
        adminService: AdminService,
        dialogService: DialogService,
        moduleService: ModuleService
    ) {
        super(adminService, dialogService, moduleService);
    }

    async deleteGlossary(): Promise<void> {
        try {
            const result = await this.deleteDialog();
            if (!result) {
                return;
            }
        } catch (e) {
            throw new Error('Failed to confirm glossary deletion.', { cause: e });
        }

        try {
            await this.glossaryService.deleteItem(this.item);
            this.snack.openSnackBarSuccess(`Glossary item ${this.item.title} deleted successfully.`);
            this.goToGlossary();
        } catch (e) {
            this.snack.openSnackBarError(e.error.message);
        }
    }

    get item(): IGlossary {
        return this.selectedItem;
    }
}
